// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"5288bf88","241":"d8e776ab","350":"571bd535","380":"f3b0b988","460":"84362f36","488":"22b449f6","509":"a0d559e2","597":"cd5ade36","728":"5417cbfa","730":"5a39430c","969":"5cdb94c6","979":"e0541ecb"}[chunkId] + ".chunk.js";
};